import { Component, Input, OnInit } from '@angular/core';
import { OverheatingAlarm } from '../../../../alarm/alarm-definitions/overheating.alarm';
import { VoltageAlarm } from '../../../../alarm/alarm-definitions/voltage.alarm';
import { WheelAlertAlarm } from '../../../../alarm/alarm-definitions/wheel-alert.alarm';
import { AlarmMessage } from '../../../../alarm/alarm-message';
import { TooltipDirective } from '../../../../components/qm-directives/tooltip-directive/tooltip.directive';
import { TooltipEvent } from '../../../../components/qm-directives/tooltip-directive/types';

const voltageAlarmHeadings = [
  'MIME-Version:',
  'Content-Type:',
  'Content-Transfer-Encoding:',
  'Return-Path:',
  'X-OriginalArrivalTime:',
  'sijainti:',
  'pvm:',
  'kalusto:',
  'syy:'
];

const hotboxAlarmHeadings = [
  'Mittausaika:',
  'mittausaika:',
  'Mittausasema:',
  'Juna:',
  'Kaluston järjestysnumero:',
  'Kalustonumero(RFID):',
  'Kalustonumero(Liike):',
  'Junatyyppi:',
  'Littera:',
  'Nopeus:',
  'Raide:',
  'Sijainti:',
  'Suunta:',
  'Orientaatio:',
  'Ulkolämpötila:',
  'Lämpötilat ja hälytykset:',
  'Akseli:',
  'Absoluuttiset lämpötilat:',
  'Suhteelliset lämpötilat:',
  'Kommentit:'
];

const wheelAlarms = [
  'Mittausaika:',
  'Mittausasema:',
  'Juna:',
  'Kaluston järjestysnumero:',
  'Kalustonumero(RFID):',
  'Kalustonumero(Liike):',
  'Junatyyppi:',
  'Littera:',
  'Nopeus:',
  'Yhteenveto hälytyksistä:',
  'Akseli:',
  'Iskuvoima:',
  'Junatyyppi:',
  'Alkuopeus:',
  'Loppunopeus:',
  'Raide:',
  'Sijainti:',
  'Suunta:',
  'Orientaatio:',
  'Ulkolämpötila:',
  'Hälytykset ja varoitukset:',
  'Kalusto:',
  'Paino:',
  'Sivupaino:',
  'Pitkittäispaino:',
  'Telin 1 paino:',
  'Telin 1 ristipaino:',
  'Telin 1 sivupaino:',
  'Akseli:',
  'Paino:',
  'Sivupaino:',
  'Vasen paino:',
  'Vasen lovi %:',
  'Iskuvoima:',
  'Kommentit:'
];

const headings = [...wheelAlarms, ...hotboxAlarmHeadings, ...voltageAlarmHeadings];

@Component({
  selector: 'qm-technical-alarm-item',
  templateUrl: './technical-alarm-item.component.html',
  styleUrls: ['./technical-alarm-item.component.scss']
})
export class TechnicalAlarmItemComponent implements OnInit {
  @Input() public alarm: AlarmMessage<VoltageAlarm | OverheatingAlarm | WheelAlertAlarm>;
  public tooltipOpen: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleTooltip(tooltipEvent: TooltipEvent, tooltip: TooltipDirective) {
    console.log(tooltipEvent, tooltip, this.alarm);

    const formattedMessage = headings
      .reduce((msg, heading) => msg.replace(heading, `\n${heading}`), this.alarm?.metadata?.payload?.message || '')
      .split('\n');

    formattedMessage[0] = formattedMessage[0].toLocaleUpperCase('fi');

    tooltip.open({
      message: formattedMessage,
      event: tooltipEvent.event,
    });
  }

}
